import { useEffect, useState } from "react";

import { apiUrl } from "../../services/config";
import { Alert } from "./Alert";

const POLL_INTERVAL_MS = 60000;
const DEFAULT_MESSAGE =
  "Editing is temporarily disabled for scheduled maintenance. You can still view your data.";

export default function MaintenanceBanner() {
  const [state, setState] = useState({ enabled: false, message: null });

  useEffect(() => {
    let alive = true;

    const poll = () =>
      fetch(`${apiUrl}/api/maintenance`)
        .then((res) => res.json())
        .then((data) => {
          if (alive) {
            setState(data);
          }
        })
        .catch(() => {});

    poll();
    const id = setInterval(poll, POLL_INTERVAL_MS);

    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  if (!state.enabled) {
    return null;
  }

  return (
    <div role="alert" aria-live="polite">
      <Alert
        type="warning"
        title="Scheduled maintenance"
        message={state.message || DEFAULT_MESSAGE}
        classes="rounded-none border-x-0 border-t-0"
      />
    </div>
  );
}
